import { render } from "./PdpaScreen.vue?vue&type=template&id=748a3d70"
import script from "./PdpaScreen.vue?vue&type=script&lang=ts"
export * from "./PdpaScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script